module.exports = __webpack_public_path__ + "img/styria-call-and-mail.898ae9a6.svg";